import {useEffect, useState} from "react";

export const useAboutData = () => {
    const [about, setAbout] = useState(null);

    useEffect(() => {
        fetch('https://texla.uz/api/v1/about/')
            .then(r => r.json())
            .then(data => setAbout(Array.isArray(data) ? data[0] : data));
    }, []);

    return { about };
};